export const sortOrders = [
    { value: 'ID_asc', labelKey: 'idAsc' },
    { value: 'ID_desc', labelKey: 'idDesc' },
    { value: 'NAME_asc', labelKey: 'nameAsc' },
    { value: 'NAME_desc', labelKey: 'nameDesc' },
    { value: 'SALE_STATUS_asc', labelKey: 'saleStatusAsc' },
    { value: 'SALE_STATUS_desc', labelKey: 'saleStatusDesc' },
    { value: 'RETEN_STATUS_asc', labelKey: 'retenStatusAsc' },
    { value: 'RETEN_STATUS_desc', labelKey: 'retenStatusDesc' },
    { value: 'MANAGER_NAME_asc', labelKey: 'managerNameAsc' },
    { value: 'MANAGER_NAME_desc', labelKey: 'managerNameDesc' },
    { value: 'PHONE_asc', labelKey: 'phoneAsc' },
    { value: 'PHONE_desc', labelKey: 'phoneDesc' },
    { value: 'EMAIL_asc', labelKey: 'emailAsc' },
    { value: 'EMAIL_desc', labelKey: 'emailDesc' },
    { value: 'GEO_asc', labelKey: 'geoAsc' },
    { value: 'GEO_desc', labelKey: 'geoDesc' },
    { value: 'LAST_COMMENT_DATE_asc', labelKey: 'lastCommentDateAsc' },
    { value: 'LAST_COMMENT_DATE_desc', labelKey: 'lastCommentDateDesc' },
    { value: 'REGISTRATION_DATE_asc', labelKey: 'registrationDateAsc' },
    { value: 'REGISTRATION_DATE_desc', labelKey: 'registrationDateDesc' },
    { value: 'AFFILIATOR_asc', labelKey: 'affiliatorAsc' },
    { value: 'AFFILIATOR_desc', labelKey: 'affiliatorDesc' },
    { value: 'LAST_COMMENT_TEXT_ASC', labelKey: 'lastCommentTextAsc' },
    { value: 'LAST_COMMENT_TEXT_DESC', labelKey: 'lastCommentTextDesc' },
    { value: 'CAMPAIGN_ASC', labelKey: 'campaignAsc' },
    { value: 'CAMPAIGN_DESC', labelKey: 'campaignDesc' },
];
